import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"plus\"><path d=\"M474 198H352c-19 0-38-16-38-38V38c0-22-16-38-36-38h-44c-20 0-36 16-36 38v122c0 19-16 38-38 38H38c-22 0-38 16-38 36v41c0 19 16 39 38 39h122c19 0 38 16 38 38v122c0 19 16 38 39 38h41c20 0 39-16 39-38V352c0-19 16-38 38-38h122c19 0 38-16 38-39v-41c-3-20-19-36-41-36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/plus.svg
// module id = 200
// module chunks = 0